export default {
  SET_HUB_SEGMENTS: 'SET_HUB_SEGMENTS',
  ASSOCIATE_HUB_SEGMENTS_REQUEST: 'ASSOCIATE_HUB_SEGMENTS_REQUEST',
  ASSOCIATE_HUB_SEGMENTS_SUCCESS: 'ASSOCIATE_HUB_SEGMENTS_SUCCESS',
  ASSOCIATE_HUB_SEGMENTS_FAILURE: 'ASSOCIATE_HUB_SEGMENTS_FAILURE',
  TOGGLE_HUB_SEGMENT: 'TOGGLE_HUB_SEGMENT'
}
